import paginationComponent from '../../../components/pagination/pagination.component';
import { getRecipients, exportExcel } from "../../../models/announcement/randomPing.model";
import ViewBase from '../../view-base.view';
import moment from 'moment';
import { formats as FORMATS } from "../../../config/constants";

export default function RecipientListView(vnode) {

  ViewBase.call(this);
  const DEFAULT_PAGINATION = {
    pageSize: 10,
    pageIndex: 1,
    totalItems: 0
  };

  let pagination = structuredClone(DEFAULT_PAGINATION);

  let list = [];

  const toQueryParams = () => {
    return Object.assign(
      {
        randomPingHeaderID: vnode.attrs.selectedRandomPingID,
        pageSize: pagination.pageSize,
        pageIndex: pagination.pageIndex,
      }
    );
  };

  const getData = () => {
    this.showLoading();
    getRecipients(toQueryParams())
      .then((result) => {
        if (result.data) {
          list = result.data;
          
          pagination.pageIndex = result.pageIndex;
          pagination.pageSize = result.pageSize;
          pagination.totalItems = result.total;
        }
        this.hideLoading();
      })
      .catch((error) => {
        this.hideLoading();
        this.handleError(error)
      })
      .finally(() => {
        this.hideLoading();
      })
  }

  const downloadExcel = () => {
    this.showLoading();
    const params = {
      sortBy: "",
      orderBy: "",
      pageIndex: 0,
      pageSize: 0,
      storedProcedureCode: "82",
      params: [
        { code: "168", value: vnode.attrs.selectedRandomPingID },
        { code: "2", value: "" }, 
        { code: "3", value: "0" }, 
        { code: "4", value: "0" }
      ],
      excelSheetNames: ["Recipient List"]
    };
    const FILE_NAME = `Recipient-List-${moment(new Date()).format(FORMATS.apiDateFormat)}.xlsx`
    exportExcel(params, FILE_NAME)
      .catch((error => {
        this.handleError(error);
      }))
      .finally(() => {
        this.hideLoading();
      })
  }

  return {
    oninit: function (vnode) {
      if (vnode.attrs.selectedRandomPingID) {
        getData()
      }
    },
    view: (vnode) => {
      console.log('list====>', list)
      return [
        m('.card',
          m('.card-body',
            m('.d-flex.justify-content-between.align-items-center mb-2',
            m('h4', this.getText("LT00000053", "Recipient List")),
              m('a.primary-link.title-link', { onclick: downloadExcel },
                m('span.card-label.mb-1.fs-7',
                  m('i.bi.bi-file-earmark-arrow-down.me-0'), //this.getText("LT00000018", "Excel Download")
                )
              )
            ),
            m(".table-responsive",
              m("table.table", [
                m("thead",
                  m("tr.align-middle", [
                    m("th", { "scope": "col" }, this.getText("LT00000049", "user ID")),
                    m("th", { "scope": "col" }, this.getText("LT00000050", "User Name")),
                    m("th", { "scope": "col" }, this.getText('LT00000015', 'Status')),
                    m("th", { "scope": "col" }, this.getText("LT00008160", "Distance")),
                    m("th", { "scope": "col" }, this.getText("LT00000739", "Response Date")),
                    m("th", { "scope": "col" }, this.getText("LT00008159", "User Submit Date")),
                    m("th", { "scope": "col" }, this.getText("LT00000152", "Remarks"))
                  ])
                ),
                m("tbody",
                  list.length == 0 &&
                  m("tr", { "class": "align-middle" },
                    m("td", { "colspan": "7" }, this.getText("EM00000141", "No records found."))
                  ),
                  list.map(gc => [
                    m("tr", [
                      m("td", gc.userID),
                      m("td", gc.userName),
                      m("td", gc.pingStatusName),
                      m("td", gc.distance + "(m)"),
                      m("td", gc.submitDate ? moment(gc.submitDate).format("YYYY-MM-DD HH:mm:ss") : "N/A"),
                      m("td", gc.clientSubmitDate ? moment(gc.clientSubmitDate).format("YYYY-MM-DD HH:mm:ss") : "N/A"),
                      m("td", gc.remarks)
                    ])
                  ]),
                )
              ])
            ),
            m(paginationComponent,
              {
                currentPage: pagination.pageIndex,
                pageSize: pagination.pageSize,
                totalItems: pagination.totalItems,
                onPageChanged: (pageIndex) => {
                  pagination.pageIndex = pageIndex;
                  getData();
                },
                onPageSizeChanged: (_, pageSize) => {
                  pagination.pageIndex = DEFAULT_PAGINATION.pageIndex
                  pagination.pageSize = pageSize;
                  getData();
                }
              }
            )
          )
        ),
        this.getBaseViews()
      ]
    }
  }
}
